import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rate-finder-wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_country_selector = _resolveComponent("country-selector")!
  const _component_rate_card = _resolveComponent("rate-card")!
  const _component_rate_list_card = _resolveComponent("rate-list-card")!

  return (!_ctx.userLocationLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showCountrySelector)
          ? (_openBlock(), _createBlock(_component_country_selector, {
              key: 0,
              selectedCountry: _ctx.selectedCountry,
              "onUpdate:selectedCountry": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCountry) = $event)),
              defaultCountries: _ctx.countries
            }, null, 8, ["selectedCountry", "defaultCountries"]))
          : _createCommentVNode("", true),
        (_ctx.allRates)
          ? (_openBlock(), _createBlock(_component_rate_card, {
              key: 1,
              selectedCountryRates: _ctx.allRates,
              selectedAmount: _ctx.amount,
              singleRate: _ctx.singleRate,
              currency: _ctx.selectedCurrency,
              isBuyCredit: _ctx.showRateListCard,
              extra: _ctx.extra?.amount
            }, null, 8, ["selectedCountryRates", "selectedAmount", "singleRate", "currency", "isBuyCredit", "extra"]))
          : _createCommentVNode("", true),
        (_ctx.showRateListCard)
          ? (_openBlock(), _createBlock(_component_rate_list_card, {
              key: 2,
              selectedCountryRates: _ctx.allRates,
              currency: _ctx.selectedCurrency,
              "onUpdate:selectRate": _ctx.selectedRate
            }, null, 8, ["selectedCountryRates", "currency", "onUpdate:selectRate"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}